import { SharingMode } from "../store/types/scenarios";

/* tslint:disable */
// Pasted outputs from google spreadsheet to csv2json.com
// Exported with 14 digits of precision from 2005 to 2040 and year keys
// https://docs.google.com/spreadsheets/d/1U2RHm-JuovJgricO_2IWTCtyZ275mhyzpSx9I-0vft8/edit#gid=62192692
export interface IRow {
  [key: string]: any
  vehicleType: string,
  ownership: string,
  sharingType: SharingMode
}


const table: IRow[] = [
  {
    "2005": 3.18,
    "2006": 3.13051218456045,
    "2007": 3.08179450870486,
    "2008": 3.03383498736229,
    "2009": 2.98662182197593,
    "2010": 2.94014339760056,
    "2011": 2.89438828004513,
    "2012": 2.84934521305983,
    "2013": 2.80500311556692,
    "2014": 2.76135107893468,
    "2015": 2.71837836429376,
    "2016": 2.67607439989533,
    "2017": 2.63442877851026,
    "2018": 2.59343125486889,
    "2019": 2.55307174314056,
    "2020": 2.51334031445236,
    "2021": 2.47422719444658,
    "2022": 2.43572276087605,
    "2023": 2.39781754123701,
    "2024": 2.36050221043876,
    "2025": 2.32376758850957,
    "2026": 2.28760463833832,
    "2027": 2.2520044634513,
    "2028": 2.21695830582353,
    "2029": 2.18245754372423,
    "2030": 2.14849368959578,
    "2031": 2.11505838796567,
    "2032": 2.08214341339098,
    "2033": 2.04974066843483,
    "2034": 2.01784218167432,
    "2035": 1.98644010573947,
    "2036": 1.95552671538269,
    "2037": 1.9250944055783,
    "2038": 1.89513568965158,
    "2039": 1.865643197437,
    "2040": 1.83660967346505,
    "vehicleType": "car",
    "ownership": "private",
    "sharingType": SharingMode.BAU
  },
  {
    "2005": 3.18,
    "2006": 3.13051218456045,
    "2007": 3.08179450870486,
    "2008": 3.03383498736229,
    "2009": 2.98662182197593,
    "2010": 2.94014339760056,
    "2011": 2.89438828004513,
    "2012": 2.84934521305983,
    "2013": 2.80500311556692,
    "2014": 2.76135107893468,
    "2015": 2.71837836429376,
    "2016": 2.67607439989533,
    "2017": 2.63442877851026,
    "2018": 2.59343125486889,
    "2019": 2.55307174314056,
    "2020": 2.51334031445236,
    "2021": 2.47422719444658,
    "2022": 2.43572276087605,
    "2023": 2.39781754123701,
    "2024": 2.36050221043876,
    "2025": 2.32376758850957,
    "2026": 2.28760463833832,
    "2027": 2.2520044634513,
    "2028": 2.21695830582353,
    "2029": 2.18245754372423,
    "2030": 2.14849368959578,
    "2031": 2.11505838796567,
    "2032": 2.08214341339098,
    "2033": 2.04974066843483,
    "2034": 2.01784218167432,
    "2035": 1.98644010573947,
    "2036": 1.95552671538269,
    "2037": 1.9250944055783,
    "2038": 1.89513568965158,
    "2039": 1.865643197437,
    "2040": 1.83660967346505,
    "vehicleType": "car",
    "ownership": "private",
    "sharingType": SharingMode.Sharing
  },
  {
    "2005": 3.18,
    "2006": 3.13051218456045,
    "2007": 3.08179450870486,
    "2008": 3.03383498736229,
    "2009": 2.98662182197593,
    "2010": 2.94014339760056,
    "2011": 2.89438828004513,
    "2012": 2.84934521305983,
    "2013": 2.80500311556692,
    "2014": 2.76135107893468,
    "2015": 2.71837836429376,
    "2016": 2.67607439989533,
    "2017": 2.63442877851026,
    "2018": 2.59343125486889,
    "2019": 2.55307174314056,
    "2020": 2.51334031445236,
    "2021": 2.47422719444658,
    "2022": 2.43572276087605,
    "2023": 2.39781754123701,
    "2024": 2.36050221043876,
    "2025": 2.32376758850957,
    "2026": 2.28760463833832,
    "2027": 2.2520044634513,
    "2028": 2.21695830582353,
    "2029": 2.18245754372423,
    "2030": 2.14849368959578,
    "2031": 2.11505838796567,
    "2032": 2.08214341339098,
    "2033": 2.04974066843483,
    "2034": 2.01784218167432,
    "2035": 1.98644010573947,
    "2036": 1.95552671538269,
    "2037": 1.9250944055783,
    "2038": 1.89513568965158,
    "2039": 1.865643197437,
    "2040": 1.83660967346505,
    "vehicleType": "car",
    "ownership": "private",
    "sharingType": SharingMode.ExtremeSharing
  },
  {
    "2005": 3.18,
    "2006": 3.17588499525457,
    "2007": 3.17177531543494,
    "2008": 3.16767095365053,
    "2009": 3.16357190301964,
    "2010": 3.1594781566695,
    "2011": 3.15538970773624,
    "2012": 3.15130654936485,
    "2013": 3.14722867470921,
    "2014": 3.14315607693205,
    "2015": 3.13908874920494,
    "2016": 3.1350266847083,
    "2017": 3.13096987663138,
    "2018": 3.12691831817222,
    "2019": 3.12287200253767,
    "2020": 3.11883092294339,
    "2021": 3.1147950726138,
    "2022": 3.11076444478209,
    "2023": 3.1067390326902,
    "2024": 3.10271882958884,
    "2025": 3.09870382873743,
    "2026": 3.09469402340412,
    "2027": 3.09068940686576,
    "2028": 3.08668997240793,
    "2029": 3.08269571332488,
    "2030": 3.07870662291951,
    "2031": 3.07472269450345,
    "2032": 3.07074392139692,
    "2033": 3.06677029692882,
    "2034": 3.06280181443668,
    "2035": 3.05883846726664,
    "2036": 3.05488024877347,
    "2037": 3.05092715232051,
    "2038": 3.0469791712797,
    "2039": 3.04303629903158,
    "2040": 3.03909852896521,
    "vehicleType": "car",
    "ownership": "commercial",
    "sharingType": SharingMode.BAU
  },
  {
    "2005": 3.18,
    "2006": 3.17588499525457,
    "2007": 3.17177531543494,
    "2008": 3.16767095365053,
    "2009": 3.16357190301964,
    "2010": 3.1594781566695,
    "2011": 3.15538970773624,
    "2012": 3.15130654936485,
    "2013": 3.14722867470921,
    "2014": 3.14315607693205,
    "2015": 3.13908874920494,
    "2016": 3.1350266847083,
    "2017": 3.13096987663138,
    "2018": 3.12691831817222,
    "2019": 3.26143600126884,
    "2020": 3.2594154614717,
    "2021": 3.2573975363069,
    "2022": 3.25538222239104,
    "2023": 3.2533695163451,
    "2024": 3.25135941479442,
    "2025": 3.24935191436872,
    "2026": 3.24734701170206,
    "2027": 3.24534470343288,
    "2028": 3.24334498620397,
    "2029": 3.24134785666244,
    "2030": 3.23935331145976,
    "2031": 3.23736134725172,
    "2032": 3.23537196069846,
    "2033": 3.23338514846441,
    "2034": 3.23140090721834,
    "2035": 3.22941923363332,
    "2036": 3.22744012438673,
    "2037": 3.22546357616025,
    "2038": 3.22348958563985,
    "2039": 3.22151814951579,
    "2040": 3.21954926448261,
    "vehicleType": "car",
    "ownership": "commercial",
    "sharingType": SharingMode.Sharing
  },
  {
    "2005": 3.18,
    "2006": 3.17588499525457,
    "2007": 3.17177531543494,
    "2008": 3.16767095365053,
    "2009": 3.16357190301964,
    "2010": 3.1594781566695,
    "2011": 3.15538970773624,
    "2012": 3.15130654936485,
    "2013": 3.14722867470921,
    "2014": 3.14315607693205,
    "2015": 3.13908874920494,
    "2016": 3.1350266847083,
    "2017": 3.13096987663138,
    "2018": 3.12691831817222,
    "2019": 3.4,
    "2020": 3.4,
    "2021": 3.4,
    "2022": 3.4,
    "2023": 3.4,
    "2024": 3.4,
    "2025": 3.4,
    "2026": 3.4,
    "2027": 3.4,
    "2028": 3.4,
    "2029": 3.4,
    "2030": 3.4,
    "2031": 3.4,
    "2032": 3.4,
    "2033": 3.4,
    "2034": 3.4,
    "2035": 3.4,
    "2036": 3.4,
    "2037": 3.4,
    "2038": 3.4,
    "2039": 3.4,
    "2040": 3.4,
    "vehicleType": "car",
    "ownership": "commercial",
    "sharingType": SharingMode.ExtremeSharing
  },
  {
    "2005": 3.18,
    "2006": 3.17588499525457,
    "2007": 3.17177531543494,
    "2008": 3.16767095365053,
    "2009": 3.16357190301964,
    "2010": 3.1594781566695,
    "2011": 3.15538970773624,
    "2012": 3.15130654936485,
    "2013": 3.14722867470921,
    "2014": 3.14315607693205,
    "2015": 3.13908874920494,
    "2016": 3.1350266847083,
    "2017": 3.13096987663138,
    "2018": 3.12691831817222,
    "2019": 3.12287200253767,
    "2020": 3.11883092294339,
    "2021": 3.1147950726138,
    "2022": 3.11076444478209,
    "2023": 3.1067390326902,
    "2024": 3.10271882958884,
    "2025": 3.09870382873743,
    "2026": 3.09469402340412,
    "2027": 3.09068940686576,
    "2028": 3.08668997240793,
    "2029": 3.08269571332488,
    "2030": 3.07870662291951,
    "2031": 3.07472269450345,
    "2032": 3.07074392139692,
    "2033": 3.06677029692882,
    "2034": 3.06280181443668,
    "2035": 3.05883846726664,
    "2036": 3.05488024877347,
    "2037": 3.05092715232051,
    "2038": 3.0469791712797,
    "2039": 3.04303629903158,
    "2040": 3.03909852896521,
    "vehicleType": "car",
    "ownership": "public",
    "sharingType": SharingMode.BAU
  },
  {
    "2005": 3.18,
    "2006": 3.17588499525457,
    "2007": 3.17177531543494,
    "2008": 3.16767095365053,
    "2009": 3.16357190301964,
    "2010": 3.1594781566695,
    "2011": 3.15538970773624,
    "2012": 3.15130654936485,
    "2013": 3.14722867470921,
    "2014": 3.14315607693205,
    "2015": 3.13908874920494,
    "2016": 3.1350266847083,
    "2017": 3.13096987663138,
    "2018": 3.12691831817222,
    "2019": 3.26143600126884,
    "2020": 3.2594154614717,
    "2021": 3.2573975363069,
    "2022": 3.25538222239104,
    "2023": 3.2533695163451,
    "2024": 3.25135941479442,
    "2025": 3.24935191436872,
    "2026": 3.24734701170206,
    "2027": 3.24534470343288,
    "2028": 3.24334498620397,
    "2029": 3.24134785666244,
    "2030": 3.23935331145976,
    "2031": 3.23736134725172,
    "2032": 3.23537196069846,
    "2033": 3.23338514846441,
    "2034": 3.23140090721834,
    "2035": 3.22941923363332,
    "2036": 3.22744012438673,
    "2037": 3.22546357616025,
    "2038": 3.22348958563985,
    "2039": 3.22151814951579,
    "2040": 3.21954926448261,
    "vehicleType": "car",
    "ownership": "public",
    "sharingType": SharingMode.Sharing
  },
  {
    "2005": 3.18,
    "2006": 3.17588499525457,
    "2007": 3.17177531543494,
    "2008": 3.16767095365053,
    "2009": 3.16357190301964,
    "2010": 3.1594781566695,
    "2011": 3.15538970773624,
    "2012": 3.15130654936485,
    "2013": 3.14722867470921,
    "2014": 3.14315607693205,
    "2015": 3.13908874920494,
    "2016": 3.1350266847083,
    "2017": 3.13096987663138,
    "2018": 3.12691831817222,
    "2019": 3.4,
    "2020": 3.4,
    "2021": 3.4,
    "2022": 3.4,
    "2023": 3.4,
    "2024": 3.4,
    "2025": 3.4,
    "2026": 3.4,
    "2027": 3.4,
    "2028": 3.4,
    "2029": 3.4,
    "2030": 3.4,
    "2031": 3.4,
    "2032": 3.4,
    "2033": 3.4,
    "2034": 3.4,
    "2035": 3.4,
    "2036": 3.4,
    "2037": 3.4,
    "2038": 3.4,
    "2039": 3.4,
    "2040": 3.4,
    "vehicleType": "car",
    "ownership": "public",
    "sharingType": SharingMode.ExtremeSharing
  },
  {
    "2005": 1.75,
    "2006": 1.75066489540832,
    "2007": 1.75133004343715,
    "2008": 1.75199544418248,
    "2009": 1.75266109774032,
    "2010": 1.75332700420673,
    "2011": 1.7539931636778,
    "2012": 1.75465957624965,
    "2013": 1.75532624201846,
    "2014": 1.75599316108041,
    "2015": 1.75666033353174,
    "2016": 1.75732775946873,
    "2017": 1.75799543898769,
    "2018": 1.75866337218496,
    "2019": 1.75933155915692,
    "2020": 1.76,
    "2021": 1.76066869481065,
    "2022": 1.76133764368536,
    "2023": 1.76200684672066,
    "2024": 1.76267630401312,
    "2025": 1.76334601565934,
    "2026": 1.76401598175596,
    "2027": 1.76468620239965,
    "2028": 1.76535667768714,
    "2029": 1.76602740771515,
    "2030": 1.7666983925805,
    "2031": 1.76736963237998,
    "2032": 1.76804112721048,
    "2033": 1.76871287716888,
    "2034": 1.76938488235211,
    "2035": 1.77005714285715,
    "2036": 1.770729658781,
    "2037": 1.77140243022071,
    "2038": 1.77207545727336,
    "2039": 1.77274874003606,
    "2040": 1.77342227860597,
    "vehicleType": "autoRickshaw",
    "ownership": "commercial",
    "sharingType": SharingMode.BAU
  },
  {
    "2005": 1.75,
    "2006": 1.75066489540832,
    "2007": 1.75133004343715,
    "2008": 1.75199544418248,
    "2009": 1.75266109774032,
    "2010": 1.75332700420673,
    "2011": 1.7539931636778,
    "2012": 1.75465957624965,
    "2013": 1.75532624201846,
    "2014": 1.75599316108041,
    "2015": 1.75666033353174,
    "2016": 1.75732775946873,
    "2017": 1.75799543898769,
    "2018": 1.75866337218496,
    "2019": 2.27966577957846,
    "2020": 2.28,
    "2021": 2.28033434740533,
    "2022": 2.28066882184268,
    "2023": 2.28100342336033,
    "2024": 2.28133815200656,
    "2025": 2.28167300782967,
    "2026": 2.28200799087798,
    "2027": 2.28234310119983,
    "2028": 2.28267833884357,
    "2029": 2.28301370385758,
    "2030": 2.28334919629025,
    "2031": 2.28368481618999,
    "2032": 2.28402056360524,
    "2033": 2.28435643858444,
    "2034": 2.28469244117605,
    "2035": 2.28502857142857,
    "2036": 2.2853648293905,
    "2037": 2.28570121511035,
    "2038": 2.28603772863668,
    "2039": 2.28637437001803,
    "2040": 2.28671113930299,
    "vehicleType": "autoRickshaw",
    "ownership": "commercial",
    "sharingType": SharingMode.Sharing
  },
  {
    "2005": 1.75,
    "2006": 1.75066489540832,
    "2007": 1.75133004343715,
    "2008": 1.75199544418248,
    "2009": 1.75266109774032,
    "2010": 1.75332700420673,
    "2011": 1.7539931636778,
    "2012": 1.75465957624965,
    "2013": 1.75532624201846,
    "2014": 1.75599316108041,
    "2015": 1.75666033353174,
    "2016": 1.75732775946873,
    "2017": 1.75799543898769,
    "2018": 1.75866337218496,
    "2019": 2.8,
    "2020": 2.8,
    "2021": 2.8,
    "2022": 2.8,
    "2023": 2.8,
    "2024": 2.8,
    "2025": 2.8,
    "2026": 2.8,
    "2027": 2.8,
    "2028": 2.8,
    "2029": 2.8,
    "2030": 2.8,
    "2031": 2.8,
    "2032": 2.8,
    "2033": 2.8,
    "2034": 2.8,
    "2035": 2.8,
    "2036": 2.8,
    "2037": 2.8,
    "2038": 2.8,
    "2039": 2.8,
    "2040": 2.8,
    "vehicleType": "autoRickshaw",
    "ownership": "commercial",
    "sharingType": SharingMode.ExtremeSharing
  },
  {
    "2005": 1.5,
    "2006": 1.50646775611661,
    "2007": 1.51296340014602,
    "2008": 1.51948705233635,
    "2009": 1.52603883345426,
    "2010": 1.53261886478711,
    "2011": 1.53922726814522,
    "2012": 1.54586416586415,
    "2013": 1.55252968080697,
    "2014": 1.55922393636648,
    "2015": 1.56594705646755,
    "2016": 1.57269916556939,
    "2017": 1.57948038866786,
    "2018": 1.58629085129778,
    "2019": 1.59313067953525,
    "2020": 1.6,
    "2021": 1.60689893985772,
    "2022": 1.61382762682242,
    "2023": 1.62078618915878,
    "2024": 1.62777475568455,
    "2025": 1.63479345577291,
    "2026": 1.6418424193549,
    "2027": 1.64892177692176,
    "2028": 1.65603165952743,
    "2029": 1.66317219879091,
    "2030": 1.67034352689872,
    "2031": 1.67754577660735,
    "2032": 1.68477908124571,
    "2033": 1.69204357471763,
    "2034": 1.69933939150426,
    "2035": 1.70666666666667,
    "2036": 1.71402553584824,
    "2037": 1.72141613527725,
    "2038": 1.72883860176936,
    "2039": 1.73629307273019,
    "2040": 1.74377968615778,
    "vehicleType": "twoWheel",
    "ownership": "private",
    "sharingType": SharingMode.BAU
  },
  {
    "2005": 1.5,
    "2006": 1.50646775611661,
    "2007": 1.51296340014602,
    "2008": 1.51948705233635,
    "2009": 1.52603883345426,
    "2010": 1.53261886478711,
    "2011": 1.53922726814522,
    "2012": 1.54586416586415,
    "2013": 1.55252968080697,
    "2014": 1.55922393636648,
    "2015": 1.56594705646755,
    "2016": 1.57269916556939,
    "2017": 1.57948038866786,
    "2018": 1.58629085129778,
    "2019": 1.59313067953525,
    "2020": 1.6,
    "2021": 1.60689893985772,
    "2022": 1.61382762682242,
    "2023": 1.62078618915878,
    "2024": 1.62777475568455,
    "2025": 1.63479345577291,
    "2026": 1.6418424193549,
    "2027": 1.64892177692176,
    "2028": 1.65603165952743,
    "2029": 1.66317219879091,
    "2030": 1.67034352689872,
    "2031": 1.67754577660735,
    "2032": 1.68477908124571,
    "2033": 1.69204357471763,
    "2034": 1.69933939150426,
    "2035": 1.70666666666667,
    "2036": 1.71402553584824,
    "2037": 1.72141613527725,
    "2038": 1.72883860176936,
    "2039": 1.73629307273019,
    "2040": 1.74377968615778,
    "vehicleType": "twoWheel",
    "ownership": "private",
    "sharingType": SharingMode.Sharing
  },
  {
    "2005": 1.5,
    "2006": 1.50646775611661,
    "2007": 1.51296340014602,
    "2008": 1.51948705233635,
    "2009": 1.52603883345426,
    "2010": 1.53261886478711,
    "2011": 1.53922726814522,
    "2012": 1.54586416586415,
    "2013": 1.55252968080697,
    "2014": 1.55922393636648,
    "2015": 1.56594705646755,
    "2016": 1.57269916556939,
    "2017": 1.57948038866786,
    "2018": 1.58629085129778,
    "2019": 1.59313067953525,
    "2020": 1.6,
    "2021": 1.60689893985772,
    "2022": 1.61382762682242,
    "2023": 1.62078618915878,
    "2024": 1.62777475568455,
    "2025": 1.63479345577291,
    "2026": 1.6418424193549,
    "2027": 1.64892177692176,
    "2028": 1.65603165952743,
    "2029": 1.66317219879091,
    "2030": 1.67034352689872,
    "2031": 1.67754577660735,
    "2032": 1.68477908124571,
    "2033": 1.69204357471763,
    "2034": 1.69933939150426,
    "2035": 1.70666666666667,
    "2036": 1.71402553584824,
    "2037": 1.72141613527725,
    "2038": 1.72883860176936,
    "2039": 1.73629307273019,
    "2040": 1.74377968615778,
    "vehicleType": "twoWheel",
    "ownership": "private",
    "sharingType": SharingMode.ExtremeSharing
  },
  {
    "2005": 1.5,
    "2006": 1.50646775611661,
    "2007": 1.51296340014602,
    "2008": 1.51948705233635,
    "2009": 1.52603883345426,
    "2010": 1.53261886478711,
    "2011": 1.53922726814522,
    "2012": 1.54586416586415,
    "2013": 1.55252968080697,
    "2014": 1.55922393636648,
    "2015": 1.56594705646755,
    "2016": 1.57269916556939,
    "2017": 1.57948038866786,
    "2018": 1.58629085129778,
    "2019": 1.59313067953525,
    "2020": 1.6,
    "2021": 1.60689893985772,
    "2022": 1.61382762682242,
    "2023": 1.62078618915878,
    "2024": 1.62777475568455,
    "2025": 1.63479345577291,
    "2026": 1.6418424193549,
    "2027": 1.64892177692176,
    "2028": 1.65603165952743,
    "2029": 1.66317219879091,
    "2030": 1.67034352689872,
    "2031": 1.67754577660735,
    "2032": 1.68477908124571,
    "2033": 1.69204357471763,
    "2034": 1.69933939150426,
    "2035": 1.70666666666667,
    "2036": 1.71402553584824,
    "2037": 1.72141613527725,
    "2038": 1.72883860176936,
    "2039": 1.73629307273019,
    "2040": 1.74377968615778,
    "vehicleType": "twoWheel",
    "ownership": "commercial",
    "sharingType": SharingMode.BAU
  },
  {
    "2005": 1.5,
    "2006": 1.50646775611661,
    "2007": 1.51296340014602,
    "2008": 1.51948705233635,
    "2009": 1.52603883345426,
    "2010": 1.53261886478711,
    "2011": 1.53922726814522,
    "2012": 1.54586416586415,
    "2013": 1.55252968080697,
    "2014": 1.55922393636648,
    "2015": 1.56594705646755,
    "2016": 1.57269916556939,
    "2017": 1.57948038866786,
    "2018": 1.58629085129778,
    "2019": 1.67156533976762,
    "2020": 1.675,
    "2021": 1.67844946992886,
    "2022": 1.68191381341121,
    "2023": 1.68539309457939,
    "2024": 1.68888737784227,
    "2025": 1.69239672788646,
    "2026": 1.69592120967745,
    "2027": 1.69946088846088,
    "2028": 1.70301582976372,
    "2029": 1.70658609939545,
    "2030": 1.71017176344936,
    "2031": 1.71377288830367,
    "2032": 1.71738954062286,
    "2033": 1.72102178735881,
    "2034": 1.72466969575213,
    "2035": 1.72833333333333,
    "2036": 1.73201276792412,
    "2037": 1.73570806763862,
    "2038": 1.73941930088468,
    "2039": 1.74314653636509,
    "2040": 1.74688984307889,
    "vehicleType": "twoWheel",
    "ownership": "commercial",
    "sharingType": SharingMode.Sharing
  },
  {
    "2005": 1.5,
    "2006": 1.50646775611661,
    "2007": 1.51296340014602,
    "2008": 1.51948705233635,
    "2009": 1.52603883345426,
    "2010": 1.53261886478711,
    "2011": 1.53922726814522,
    "2012": 1.54586416586415,
    "2013": 1.55252968080697,
    "2014": 1.55922393636648,
    "2015": 1.56594705646755,
    "2016": 1.57269916556939,
    "2017": 1.57948038866786,
    "2018": 1.58629085129778,
    "2019": 1.75,
    "2020": 1.75,
    "2021": 1.75,
    "2022": 1.75,
    "2023": 1.75,
    "2024": 1.75,
    "2025": 1.75,
    "2026": 1.75,
    "2027": 1.75,
    "2028": 1.75,
    "2029": 1.75,
    "2030": 1.75,
    "2031": 1.75,
    "2032": 1.75,
    "2033": 1.75,
    "2034": 1.75,
    "2035": 1.75,
    "2036": 1.75,
    "2037": 1.75,
    "2038": 1.75,
    "2039": 1.75,
    "2040": 1.75,
    "vehicleType": "twoWheel",
    "ownership": "commercial",
    "sharingType": SharingMode.ExtremeSharing
  }
];

export default table;



// WEBPACK FOOTER //
// ./src/data/occupancy.ts